// src/pages/VentingRoomContent/PostModal.js
import React, { useState } from 'react';
import {
    FaFile,
    FaVideo,
    FaMicrophone,
    FaImage,
} from 'react-icons/fa';
import '../../styles/VentingRoomDashboard.css';

const API_BASE = "http://localhost:5000";

function PostModal({ isOpen, onClose, topicId, userEmail, onPostSuccess }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileType, setFileType] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    if (!isOpen) return null;

    const handleFileChange = (event, type) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            setFileType(type);
            setMessage('');
            setUploadProgress(0);
        }
    };

    const handleUpload = async () => {
        if (!selectedFile || !fileType || !userEmail) {
            setMessage('Please select a file and ensure you are authenticated.');
            setMessageType('error');
            return;
        }

        setUploading(true);
        setMessage('Uploading...');
        setMessageType('');

        // Prepare the form data to send the file and metadata
        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('topicId', topicId);
        formData.append('userEmail', userEmail);
        formData.append('fileType', fileType);

        try {
            const response = await fetch(`${API_BASE}/api/venting-room/upload-post`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log("Post uploaded successfully:", data);

            setMessage('Post uploaded successfully!');
            setMessageType('success');
            onPostSuccess();
        } catch (err) {
            console.error("Upload failed:", err);
            setMessage(`Upload failed: ${err.message}`);
            setMessageType('error');
        } finally {
            setUploading(false);
            setSelectedFile(null);
            setFileType(null);
            setUploadProgress(0);
        }
    };

    return (
        <div className="post-modal-overlay">
            <div className="post-modal-content">
                <h3>Post to {topicId}</h3>
                <div className="post-options">
                    <label className="post-option-button">
                        <input type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => handleFileChange(e, 'image')} />
                        <FaImage size={30} /> <span>Image</span>
                    </label>
                    <label className="post-option-button">
                        <input type="file" accept="video/*" style={{ display: 'none' }} onChange={(e) => handleFileChange(e, 'video')} />
                        <FaVideo size={30} /> <span>Video</span>
                    </label>
                    <label className="post-option-button">
                        <input type="file" accept=".pdf,.doc,.docx,.txt" style={{ display: 'none' }} onChange={(e) => handleFileChange(e, 'doc')} />
                        <FaFile size={30} /> <span>Document</span>
                    </label>
                    <label className="post-option-button">
                        <input type="file" accept="audio/*" style={{ display: 'none' }} onChange={(e) => handleFileChange(e, 'audio')} />
                        <FaMicrophone size={30} /> <span>Audio</span>
                    </label>
                </div>

                {selectedFile && (
                    <div className="selected-file-info">
                        <p>Selected: {selectedFile.name} ({fileType})</p>
                        {uploading && <progress value={uploadProgress} max="100"></progress>}
                        {message && <p className={`upload-message ${messageType}`}>{message}</p>}
                        <button onClick={handleUpload} disabled={uploading} className="upload-button">
                            {uploading ? 'Uploading...' : 'Upload Post'}
                        </button>
                    </div>
                )}

                <button onClick={onClose} className="close-modal-button">Close</button>
            </div>
        </div>
    );
}

export default PostModal;
